import { howItWorksSteps } from "@/mocks/siteContent";

export default function HowItWorks() {
  return (
    <section className="mx-auto w-full max-w-[1400px] px-6 py-14 md:py-16">
      <div className="rounded-lg border border-background-200 bg-background-50 p-8 md:p-10">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-secondary-700">
              <span className="h-1 w-1 rounded-full bg-accent-500" />
              How it works
            </span>
            <h3 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              Three steps to the right local business
            </h3>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
          {howItWorksSteps.map((step, index) => (
            <div key={step.id} className="relative flex gap-4">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${step.icon} text-xl`} />
              </span>
              <div>
                <span className="text-xs font-bold uppercase tracking-wider text-accent-600">
                  Step {index + 1}
                </span>
                <h4 className="mt-1 font-heading text-base font-bold text-foreground-950">
                  {step.title}
                </h4>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}